import { Ownership } from "@repo/api/schemas/policiesInventory.schema";
import { type MenuMultiOption } from "@saviynt/design-system";

export function sortOwners(owners: Ownership[]) {
  return owners.sort((a, b) => {
    // First, compare status
    if (a.status === b.status) {
      // If status is same, sort by name
      return a.name.localeCompare(b.name);
    }

    // If statuses are different, put 'Inactive' first
    return a.status.toLowerCase() === "inactive" ? -1 : 1;
  });
}
export const operatorValues = {
  EQ: "EQ",
  IN: "IN",
} as const;

/**
 * Type for filter operators (EQ = equals, IN = in list)
 */
export type OperatorValuesType =
  (typeof operatorValues)[keyof typeof operatorValues];
export interface SelectedWidgetFilterType {
  field: string;
  operator: OperatorValuesType;
  values: string[];
}

export const isMenuMultiOptionArray = (
  value: MenuMultiOption[] | MenuMultiOption | undefined,
): value is MenuMultiOption[] => Array.isArray(value);

export const extractMultiSelectOptions = (
  selectedOptions?: MenuMultiOption[] | MenuMultiOption,
): MenuMultiOption[] =>
  isMenuMultiOptionArray(selectedOptions) ? selectedOptions : [];

export const extractSingleSelectOption = (
  selectedOption?: MenuMultiOption[] | MenuMultiOption,
): MenuMultiOption | undefined =>
  isMenuMultiOptionArray(selectedOption) ? selectedOption[0] : selectedOption;

export const getSelectedFilterValues = (
  selectedFilter: SelectedWidgetFilterType[] | undefined,
  field: string,
): string[] => {
  if (!Array.isArray(selectedFilter)) {
    return [];
  }

  const filterItem = selectedFilter.find((f) => f.field === field);

  return filterItem?.values ?? [];
};
